if (!customElements.get("zoom-modal")) {
  class ZoomModal extends HTMLElement {
    static OPEN_CLASS = "is-open";

    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle(ZoomModal.OPEN_CLASS);

      if(this.classList.contains(ZoomModal.OPEN_CLASS)) {
        document.body.style.width = '100%';
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
      } else {
        document.body.style.width = '';
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: parseInt(scrollY) * -1, behavior: 'instant' });
      }
    }

    disconnectedCallback() {
      document.removeEventListener("zoom:toggle", this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener("zoom:toggle", this.handleToggleRef);
    }
  }

  customElements.define("zoom-modal", ZoomModal);
}
